<template>
  <section class="elastic">
    <div class="hero">
      <div class="wrapper">
        <h1 class="intro-title">Rees Solutions Elastic Status</h1>
        <article class="intro-text">Are you concerned about elasticsearch issues? They can cause the collaspe of your category pages, search functionality and the ability for your customers to use your website.</article>
      </div>
    </div>
    <div class="content">
      <div class="wrapper">
        <h2 class="module-title"><a :href="link_href" title="Elastic Status">Get It On Github</a></h2>
        <div class="modules_grid">
          <div id="info" class="module">
            <h3>What is Elastic Status?</h3>
            <p>Elastic Status is your warning and notification system. It is always better not to have problems with your website but the only thing worse is not knowing about the problems. Elastic status gets the health status from the elasticsearch health api and sends a notification email if it detects a problem. You can get this module for free on <a :href="link_href" title="Elastic Status">github</a> or via composer (instructions below).
            </p>
          </div>
          <div id="features" class="module">
            <h3>Our Feature Set &amp; Extension Details</h3>
            <ul>
              <li>Cron based Email notifications of issues.</li>
              <li>Status &amp; email send request in the admin interface</li>
              <li>Open Source</li>
              <li>Available via composer</li>
            </ul>
            <h4>Composer Instalation Instructions:</h4>
            <p><strong>Add the Repository:</strong></p>
            <code><i @click="copyEvent"></i>composer config repositories.elastic-status vcs https://github.com/Sental/elastic-status.git</code>
            <p><strong>Require the Module:</strong></p>
            <code><i @click="copyEvent"></i>composer require reessolutions/elastic-status:*</code>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ElasticStatus',
  data () {
    return {
      msg: 'Elastic Status',
      content: 'Elastic Status is an open source Magento 2 extension. It is designed to help you periodically monitor for Elasticsearch downtime and alert you if it detects a problem. Elasticsearch downtime means category downtime, products dissappearing and your website search ceasing to function. The first step in preventing the loss of revenue from this problem is knowing it is happening. Then you can get it fixed.',
      link_href: 'https://github.com/Sental/elastic-status',
      link_text: 'Get Elastic Status Here!!'
    }
  },
  methods: {
    copyToClipboard (str) {
      const el = document.createElement('textarea') // Create a <textarea> element
      el.value = str // Set its value to the string that you want copied
      el.setAttribute('readonly', '') // Make it readonly to be tamper-proof
      el.style.position = 'absolute'
      el.style.left = '-9999px' // Move outside the screen to make it invisible
      document.body.appendChild(el) // Append the <textarea> element to the HTML document
      const selected =
        document.getSelection().rangeCount > 0 // Check if there is any content selected previously
          ? document.getSelection().getRangeAt(0) // Store selection if found
          : false // Mark as false to know no selection existed before
      el.select() // Select the <textarea> content
      document.execCommand('copy') // Copy - only works as a result of a user action (e.g. click events)
      document.body.removeChild(el) // Remove the <textarea> element
      if (selected) { // If a selection existed before copying
        document.getSelection().removeAllRanges() // Unselect everything on the HTML document
        document.getSelection().addRange(selected) // Restore the original selection
      }
    },
    copyEvent (event) {
      document.querySelectorAll('code').forEach(
        code => code.classList.remove('copied')
      )
      let parent = event.target.parentNode
      this.copyToClipboard(parent.innerText)
      parent.classList.add('copied')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
h4 {
  color: #646464;
  font-size: 32px;
}
ul {
  color: #646464;
  list-style: "\276F ";
  margin-left: 28px;
}
code {
  background-color: darken(#f2f2f2, 15%);
  border-radius: 4px;
  border: 1px solid transparent;
  display: block;
  padding: 6px;
  position: relative;
  i::after {
    content: '';
    background: url(/static/clipboards.svg) no-repeat bottom center;
    background-size: cover;
    padding: 2px;
    position: absolute;
    top: 0; right: 0;
    width: 20px; height: 20px;
  }
  &.copied {
    i::after {
      background: url(/static/copied.svg) no-repeat bottom center;
      fill: #6AB6BE;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ElasticStatus.vue